import { helpers, React, ts, ui } from '_core';

import { transform } from './helpers';
import { Params } from './types';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  portfolios: string;
  fullScreen: boolean;
  hasBenchmark: boolean;
  scale: ts.enums.SCALE_ENUM;
  params: Params;
  title: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
};

const Chart = ({
  id,
  readOnly,
  params,
  fullScreen,
  hasBenchmark = false,
  loadWidgetData,
  title,
  portfolios,
}: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) {
        // rename end_date to date
        response.data.forEach((row) => {
          row.date = row.end_date;
          delete row.end_date;
        });

        setData(transform(response.data, params.isBasket, hasBenchmark, params.showTargetWeight));
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      withoutValuePadding
    />
  );
};

export default Chart;
